import { render, staticRenderFns } from "./BuyerDashboard.vue?vue&type=template&id=521b27f5&scoped=true"
import script from "./BuyerDashboard.vue?vue&type=script&lang=js"
export * from "./BuyerDashboard.vue?vue&type=script&lang=js"
import style0 from "./BuyerDashboard.vue?vue&type=style&index=0&id=521b27f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521b27f5",
  null
  
)

export default component.exports